import axios from "axios";

const createAxios = (baseURL, contentType) => {
  const instance = axios.create({
    baseURL: baseURL,
    headers: {
      Accept: "application/json",
      "Content-Type": contentType,
    },
  });

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("userToken");
    const isPublicAuthUrl = config.url && (
      config.url.includes("/auth/login/") || 
      config.url.includes("/auth/forgot_password/") || 
      config.url.includes("/auth/reset_password/") || 
      config.url.includes("/auth/set_new_password/")
    );
    if (!config.skipAuth && token && !isPublicAuthUrl) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err.response?.status === 401) {
        localStorage.removeItem("userToken");
      }
      return Promise.reject(err);
    }
  );

  return instance;
};

const BASE_URL = process.env.NEXT_PUBLIC_BACKEND_BASE_URL;

export const httpAdmin     = createAxios(BASE_URL, "application/json");
export const httpAdminForm = createAxios(BASE_URL, "multipart/form-data");

const {
  get:    getAdmin,
  post:   postAdmin,
  put:    putAdmin,
  delete: destroyAdmin,
  patch:  patchAdmin,
} = httpAdmin;

const {
  post:   postAdminForm,
  put:    putAdminForm,
  delete: destroyAdminForm,
  patch:  patchAdminForm,
} = httpAdminForm;

// Blob variant — used for report downloads so the browser gets a binary file
// instead of garbled text. Passes the same auth interceptor as getAdmin.
const getAdminBlob = (url) =>
  httpAdmin.get(url, { responseType: "blob" });

export {
  getAdmin,
  getAdminBlob,   // ← added
  postAdmin,
  putAdmin,
  destroyAdmin,
  patchAdmin,
  postAdminForm,
  putAdminForm,
  destroyAdminForm,
  patchAdminForm,
};